"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditResponseOptionsCms = void 0;
var CreditResponseOptionsCms = /** @class */ (function () {
    function CreditResponseOptionsCms() {
        this.prePaidCommonMessageLabel = "Based on your credit check, you have a choice to make about\n     your order.";
        this.downPaymentOnlyMessageLabel = 'You can pay a down payment on your device, or go month-to-month instead.';
        this.advancedPaymentOnlyMessageLabel = "You can pay an advance payment on your device, or go month-to-month on\n     a different wireless plan.";
        this.downAndAdvancedPaymentOnlyMessageLabel = "You can pay a down payment or advance payment on your device,\n     or go month-to-month on a different wireless plan.";
        this.downPaymentOnlyLabel = 'Make a down payment on my devices';
        this.advancedPaymentOnlyLabel = 'Pay an advance payment on my devices';
        this.downAndAdvancedPaymentOnlyLabel = 'Make a down payment or advance payment on my devices';
        this.downPaymentOnlyDesciptionLabel = "The down payment will lower the monthly price of your device\n     installment plan by {0}.";
        this.advancedPaymentOnlyDesciptionLabel = 'The advance payment will be applied as a credit to your first bill.';
        this.downAndAdvancedPaymentOnlyDesciptionLabel = "The down payment will lower the monthly price of your\n     device installment plan by {0}. The advance payment will be applied as a credit to your first bill.";
        this.downPaymentOrderTotalsLabel = 'Updated totals';
        this.downPaymentDueTodayLabel = 'Due today';
        this.downPaymentDueMonthlyLabel = 'Due monthly';
        this.prePaidContinueOptionLabel = 'Switch to a month-to-month plan';
        this.prePaidContinueOptionDescriptionLabel = "Pay as you go with AT&T PREPAID&#8480;. It&#39;s a flexible option on\n     the same great network.";
        this.prePaidContinueOrderTotalsLabel = 'New estimated totals';
        this.prePaidContinueDeivceCostLabel = 'Device cost';
        this.prePaidContinueDueMonthlyLabel = 'Payment for monthly plan';
        this.continueButtonLabel = 'Continue';
    }
    return CreditResponseOptionsCms;
}());
exports.CreditResponseOptionsCms = CreditResponseOptionsCms;
//# sourceMappingURL=CreditResponseOptions.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/CreditResponseModal/CreditResponseOptions/CreditResponseOptions.cms.js
// module id = 953
// module chunks = 8